<template>
  <n-config-provider :theme="darkTheme" :theme-overrides="themeOverrides">
    <n-message-provider>
      <n-dialog-provider>
        <MessageBridge />
        <div class="app-shell">
          <header v-if="showNav" class="app-nav">
            <span class="app-title">Campanhas DW Corp</span>
            <nav>
              <router-link to="/dashboard">Dashboard</router-link>
              <router-link to="/form">Nova Campanha</router-link>
              <a href="#" @click.prevent="logout">Sair</a>
            </nav>
          </header>
          <router-view></router-view>
        </div>
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script>
import { defineComponent } from "vue";
import { darkTheme, useMessage } from "naive-ui";
import { clearAdminToken } from "./services/api";

// Exposes the message API to Options-API components via window.$message
const MessageBridge = defineComponent({
  name: "MessageBridge",
  setup() {
    window.$message = useMessage();
    return () => null;
  },
});

export default {
  name: "RootPage",
  components: { MessageBridge },
  data() {
    return {
      darkTheme,
      themeOverrides: {
        common: {
          primaryColor: "#367934",
          primaryColorHover: "#2d5f2a",
          primaryColorPressed: "#254d23",
          bodyColor: "#1c1127",
          cardColor: "#4a3c56",
          modalColor: "#4a3c56",
        },
      },
    };
  },
  computed: {
    showNav() {
      return this.$route.name !== "login";
    },
  },
  methods: {
    logout() {
      clearAdminToken();
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style>
body {
  margin: 0;
  background-color: #1c1127;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
}

.app-shell {
  min-height: 100vh;
}

.app-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  background-color: #4a3c56;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

.app-title {
  font-weight: bold;
  font-size: 16px;
}

.app-nav nav {
  display: flex;
  gap: 18px;
}

.app-nav a {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
}

.app-nav a.router-link-active {
  color: #7fd67c;
  font-weight: bold;
}
</style>
